import React from 'react';
import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <div className="bg-[#ECEEF1] py-24 sm:py-32 text-center">
      <div className="max-w-xl mx-auto px-4 sm:px-6">
        <div className="w-14 h-14 rounded-full bg-amber-100 text-amber-800 flex items-center justify-center mx-auto mb-4">
          <i className="fa-solid fa-lock text-xl" aria-hidden="true" />
        </div>
        <span className="text-xs uppercase tracking-widest font-semibold text-[#5A232E] block mb-2">
          Fejl 403
        </span>
        <h1 className="font-display text-3xl sm:text-4xl text-[#5A232E] mb-3">
          Adgang nægtet
        </h1>
        <p className="text-sm text-[#6c7480] leading-relaxed mb-8">
          Du har ikke tilladelse til at tilgå denne ressource eller side.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[#5A232E] text-white font-medium text-sm hover:bg-[#431722] transition-colors"
        >
          <i className="fa-solid fa-arrow-left text-xs" aria-hidden="true" />
          <span>Tilbage til forsiden</span>
        </Link>
      </div>
    </div>
  );
}
